// Status ramps generated from the design system's Error and positive swatches.
// 500 is the swatch itself; the other stops follow the contour of the DLS scale
// of the same hue (per-hue, not a shared lightness ladder — DLS anchors each
// 500 at its own colour, e.g. green.500 sits at L=40% where red.500 sits at 52%).
const red = {
  '25': '#FFF4F3',
  '50': '#FFE7E6',
  '100': '#FFD8D5',
  '200': '#FFC9C6',
  '300': '#FFA5A0',
  '400': '#FF867E',
  '500': '#FF453A',
  '600': '#F90E00',
  '700': '#DD0C00',
  '800': '#4E0602',
  '900': '#350401',
  '950': '#290301',
} as const;

const green = {
  '25': '#F4FBF5',
  '50': '#E7F6E8',
  '100': '#DAF1DB',
  '200': '#CCECCE',
  '300': '#99E29E',
  '400': '#7ED584',
  '500': '#31DA3C',
  '600': '#1ABC25',
  '700': '#16A01F',
  '800': '#0A370D',
  '900': '#072509',
  '950': '#051B06',
} as const;

// LevelUp's neutral ramp. Dark-only brand, so the dark end carries the surface
// stack (canvas -> card -> input -> hover) and the mid stops carry foreground
// greys; the light end is unused today but kept so the scale is complete.
const grey = {
  '25': '#F7F7F7',
  '50': '#F0F0F0',
  '100': '#DDDDDD',
  '200': '#BBBBBC',
  '300': '#8E8E93',
  '400': '#818181',
  '500': '#606062',
  '600': '#3E3E41',
  '700': '#2C2C2E',
  '800': '#252528',
  '900': '#1C1C1E',
  '950': '#131313',
} as const;

// LevelUp's brand hue. DLS maps `brand.*` onto `blue.*`; LevelUp maps it onto
// `orange.*` -- a per-theme mapping, not a new scale.
const orange = {
  '25': '#FFF3EE',
  '50': '#FFDACC',
  '100': '#FFC1AA',
  '200': '#FFA688',
  '300': '#FF8866',
  '400': '#FF6033',
  '500': '#FF3B00',
  '600': '#DD3605',
  '700': '#BB3209',
  '800': '#87290C',
  '900': '#602515',
  '950': '#3A1808',
} as const;

const whiteAlpha = {
  '25': 'rgba(255, 255, 255, 0.04)',
  '50': 'rgba(255, 255, 255, 0.06)',
  '100': 'rgba(255, 255, 255, 0.12)',
  '200': 'rgba(255, 255, 255, 0.18)',
  '300': 'rgba(255, 255, 255, 0.30)',
  '400': 'rgba(255, 255, 255, 0.40)',
  '500': 'rgba(255, 255, 255, 0.50)',
  '600': 'rgba(255, 255, 255, 0.60)',
  '700': 'rgba(255, 255, 255, 0.70)',
  '800': 'rgba(255, 255, 255, 0.80)',
  '900': 'rgba(255, 255, 255, 0.88)',
  '950': 'rgba(255, 255, 255, 0.92)',
} as const;

const blackAlpha = {
  '25': 'rgba(0, 0, 0, 0.04)',
  '50': 'rgba(0, 0, 0, 0.06)',
  '100': 'rgba(0, 0, 0, 0.12)',
  '200': 'rgba(0, 0, 0, 0.18)',
  '300': 'rgba(0, 0, 0, 0.30)',
  '400': 'rgba(0, 0, 0, 0.40)',
  '500': 'rgba(0, 0, 0, 0.50)',
  '600': 'rgba(0, 0, 0, 0.60)',
  '700': 'rgba(0, 0, 0, 0.70)',
  '800': 'rgba(0, 0, 0, 0.80)',
  '900': 'rgba(0, 0, 0, 0.88)',
  '950': 'rgba(0, 0, 0, 0.92)',
} as const;

// Approved DLS scales LevelUp does not restyle; values seeded from DLS so the
// palette is complete for any DLS component that reaches for them.
const blue = {
  '25': '#F2F6FF',
  '50': '#E0EAFF',
  '100': '#CCDCFF',
  '200': '#B8CEFF',
  '300': '#7DA9FF',
  '400': '#4580FF',
  '500': '#0050FF',
  '600': '#0041D9',
  '700': '#003AC5',
  '800': '#001647',
  '900': '#001033',
  '950': '#000D29',
} as const;

const gold = {
  '25': '#FEFCF8',
  '50': '#FDF8EE',
  '100': '#FBF3E3',
  '200': '#F9EED7',
  '300': '#FAD897',
  '400': '#F2CE88',
  '500': '#EBC271',
  '600': '#DDAD45',
  '700': '#BB9035',
  '800': '#423620',
  '900': '#2F2717',
  '950': '#261F12',
} as const;

const purple = {
  '25': '#F9F3FF',
  '50': '#F1E1FF',
  '100': '#E7CDFE',
  '200': '#DEB9FE',
  '300': '#B897FF',
  '400': '#A572FF',
  '500': '#8906FC',
  '600': '#7300D6',
  '700': '#6700C1',
  '800': '#260247',
  '900': '#1B0132',
  '950': '#160128',
} as const;

export const colors = {
  black: '#000000',
  white: '#FFFFFF',
  grey,
  orange,
  whiteAlpha,
  blackAlpha,
  red,
  green,
  blue,
  gold,
  purple,
} as const;
